import type { Entity } from '@backstage/catalog-model';

import { isApiEntity, isUserEntity } from '@backstage/catalog-model';

import { getOpenApiSpecTitle } from './getOpenApiSpecTitle';

export const getDisplayName = (entity?: Entity, fallback?: string): string => {
  if (!entity) {
    return 'No Display Name found';
  }
  let name: string | undefined;
  if (isUserEntity(entity)) {
    name = entity.spec.profile?.displayName;
  }

  if (isApiEntity(entity)) {
    name = getOpenApiSpecTitle(entity.spec.definition);
  }

  return name ?? entity.metadata.title ?? entity.metadata.name ?? fallback;
};
